import { LICENSE_CHAGES_TYPE } from 'app/config/services';
import _ from 'lodash';
import { getCompanyDataToInitialValue } from './company';
import { licensePayload } from '../payloadsStruture';

export const setupLicensePayload = ({ values, requestJsonData, isInternalForm }) => {
  let valuesCopy = { ...values };

  //Used to preserve original payload of duplicate. Vehicles were being replace by original license
  const changesTypePreservePayload = [
    LICENSE_CHAGES_TYPE.SUBSTITUICAO_VEICULO,
    LICENSE_CHAGES_TYPE.ALTERAR_PROPRIETARIO_VEICULO,
    LICENSE_CHAGES_TYPE.MUDANCA_MUNICIPIO_VEICULO,
    LICENSE_CHAGES_TYPE.MUDANCA_RAZAO_SOCIAL,
  ];

  if (requestJsonData) {
    if (isInternalForm && values.cdTipoAlteracaoLicenca) {
      if (changesTypePreservePayload.includes(values.cdTipoAlteracaoLicenca)) {
        valuesCopy = { ...requestJsonData };
        if (values.cdUsuarioRequerente) {
          valuesCopy.cdUsuarioRequerente = values.cdUsuarioRequerente;
        }
        if (values.cdUsuarioResponsavel) {
          valuesCopy.cdUsuarioResponsavel = values.cdUsuarioResponsavel;
        }
        if (values.cdUsuarioSolicitacao) {
          valuesCopy.cdUsuarioSolicitacao = values.cdUsuarioSolicitacao;
        }
        return valuesCopy;
      }
    }

    if (requestJsonData.cdTipoEmpresa) {
      valuesCopy.cdTipoEmpresa = requestJsonData.cdTipoEmpresa;
    }
    if (requestJsonData.deCpfCnpj) {
      valuesCopy.deCpfCnpj = requestJsonData.deCpfCnpj;
    }
    if (requestJsonData.nmCompleto) {
      valuesCopy.nmCompleto = requestJsonData.nmCompleto;
    }
  }
  return valuesCopy;
};

export const clearVehicleListToLicensesDuplicate = list => {
  if (!list || list.length === 0) return list;
  const temp = list.map(elem => {
    const temp = _.cloneDeep(elem);
    if (temp.cdLicenca) delete temp.cdLicenca;
    if (temp.cdLicencaVeiculo) delete temp.cdLicencaVeiculo;
    temp.veiculo.documentos = [];
    return temp;
  });
  return temp;
};

export const clearItineraryListLicensesDuplicate = list => {
  if (!list || list.length === 0) return list;
  const temp = list.map(elem => {
    const temp = _.cloneDeep(elem);
    if (temp.cdLicenca) delete temp.cdLicenca;
    if (temp.cdLicencaItinerario) delete temp.cdLicencaItinerario;
    return temp;
  });
  return temp;
};

export const clearScheduleListLicensesDuplicate = list => {
  if (!list || list.length === 0) return list;
  const temp = list.map(elem => {
    const temp = _.cloneDeep(elem);
    if (temp.cdLicenca) delete temp.cdLicenca;
    if (temp.cdLicencaHorario) delete temp.cdLicencaHorario;
    return temp;
  });
  return temp;
};

export const clearCompaniesListLicensesDuplicate = list => {
  if (!list || list.length === 0) return list;
  const temp = list.map(elem => {
    const temp = _.cloneDeep(elem);
    if (temp.cdLicenca) delete temp.cdLicenca;
    if (temp.cdLicencaEmpresa) delete temp.cdLicencaEmpresa;
    return temp;
  });
  return temp;
};

export const clearPassengersListLicensesDuplicate = list => {
  if (!list || list.length === 0) return list;
  const temp = list.map(elem => {
    const temp = _.cloneDeep(elem);
    if (temp.cdLicenca) delete temp.cdLicenca;
    if (temp.cdLicencaPassageiro) delete temp.cdLicencaPassageiro;
    return temp;
  });
  return temp;
};

export const verifyLicencaNameAndFormat = ({filteredCollectionData, index, cdLicencaName}) => {
  let tempFiltered = _.cloneDeep(filteredCollectionData);

  const tempNotExcluido = [...tempFiltered.dataBoNotExcluido];
  const tempExcluido = [...tempFiltered.dataBoExcluido];

  if (cdLicencaName && tempNotExcluido[index][cdLicencaName]) {
    tempNotExcluido[index].boExcluido = true;
    tempExcluido.push(tempNotExcluido[index]);
    tempNotExcluido.splice(index, 1);
    return [...tempNotExcluido, ...tempExcluido];
  } else {
    const tempNotExcluido = [...tempFiltered.dataBoNotExcluido];
    tempNotExcluido.splice(index, 1);
    return [...tempNotExcluido, ...tempExcluido];
  }
};

export const setupLicenseInicialValues = (internalNewRequest) => {
  let tempValues = { ...licensePayload, ...getCompanyDataToInitialValue(internalNewRequest) };
  return tempValues;
}